import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

export const getOrganizationAddressAsync = (id) => {
  const url = getUrl("organizationAddress")(id);
  return trackPromise(Call.get(url));
};

export const requestScopeAsync = (customerId) => {
  const url = getUrl("scope");
  return trackPromise(Call.get(url, {params: {customer_id: customerId}}));
};

export const requestControllersForScopeAsync = (payload) => {
  const url = getUrl("scope");
  return trackPromise(Call.post(url, payload));
};
